import { lazy } from "react";

export const CompensatoryTimeOffRequestPage = lazy(() => import("./page"));
export {
  REQUEST_COMPENSATORY_TIME_OFF_CREATE_PATH,
  REQUEST_COMPENSATORY_TIME_OFF_EDIT_PATH,
} from "./compensatory-time-off-request-path";
export { ToCompensatoryTimeOffRequest } from "./to-compensatory-time-off-request";
